import React from "react";
import { Grid } from "@mui/material";

const ViewSouthCarolina = (props) => {

    return (
        <>
            <Grid container mt={3}>
                <div className="dynamic-table">
                    <h3>South Carolina NPDES Permit Additional Information</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Time
                                </th>
                                <th>
                                    Duration(days)
                                </th>

                                <th>
                                    Precipitation Amount
                                </th>
                                <th>
                                    Discharge
                                </th>
                                <th>
                                    Location of Discharges during inspection
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {props?.swInspectionNPDES?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            {item?.date}
                                        </td>
                                        <td>
                                            {item?.time}
                                        </td><td>
                                            {item?.duration}
                                        </td><td>
                                            {item?.precipitationAmount}
                                        </td><td>
                                            {item?.discharge ? "Yes" : "No"}
                                        </td><td>
                                            {item?.locationOfDischarge}
                                        </td>
                                    </tr>
                                )
                            })}


                        </tbody>
                    </table>
                </div>
            </Grid>
        </>
    )
}

export default ViewSouthCarolina;